/**
 * Valores iniciais do formulário de Area.
 */
export const areaDefaults = {
    name: "",
    photoUrl: null,
    width: "",
    length: "",
    status: "active"
};
